import { Row, Col } from "reactstrap";
import getWelcomeName from "../WelcomeName/getWelcomeName";
import { Theme } from "../../config/constants";
import { isMobile } from "react-device-detect";
import { HiOutlineMenu } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { slideDrawer } from "../../reducers/UIReducer/UIActions";

const PageHeader = (props) => {
    const dispatch = useDispatch();
    const menuOpen = useSelector(({ui}) => ui.mobileMenuSlideDrawer);
    const {title, subtitle, icon} = props;
    const mfrName = getWelcomeName();

    return (
        <>
            {isMobile ?
            <Row style={{width: '100vw', position: 'relative', left: '12px', background: 'white', boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)'}}>
                <Col className='w-100 p-0' style={{height: '80px', alignSelf: 'center'}}>
                    <Row className='main-header' style={{letterSpacing:'.0025em', width:'100vw', justifySelf: 'center'}}>
                        <Col className="w-fc text-size-30">
                            <HiOutlineMenu 
                                onClick={() => dispatch(slideDrawer.addMobileMenu())}
                                isActive={menuOpen}
                            />
                        </Col>
                        <Col className="w-fc">
                            <Row>
                                <Col className="w-fc text-size-30" id="pageHeaderIcon">
                                    {icon}
                                </Col>
                                <Col className="ps-0 text-size-32" style={{fontWeight: '700', height: '40px', paddingTop: '5px'}}>
                                    {title}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-size-20" style={{fontWeight: '600'}}>
                                    {subtitle}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <svg width= '26px' height='26px'>
                        <linearGradient id="icon-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop stopColor={Theme().colors.gradientColorTwo} offset="0%" />
                        <stop stopColor={Theme().colors.gradientColorOne} offset="100%" />
                        </linearGradient>
                    </svg>
                </Col>
            </Row>
            :
            <Row style={{width: 'calc(100vw - 250px)', height: '100px', position: 'relative', left: '-4px', background: 'white', boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)'}}>
                <Col className='w-100 p-0' style={{height: '80px', alignSelf: 'center'}}>
                    <Row className='main-header' style={{letterSpacing:'.0025em', width:'100%', justifySelf: 'center'}}>
                        <Col className="w-fc text-size-30" id="pageHeaderIcon">
                            {icon}
                        </Col>
                        <Col className="w-fc ps-0" style={{paddingTop: '2px'}}>
                            <Row>
                                <Col className="text-size-32" style={{fontWeight: '700', height: '40px'}}>
                                    {title}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-size-20" style={{fontWeight: '600'}}>
                                    {subtitle}
                                </Col>
                            </Row>
                        </Col>
                        <Col></Col>
                        <Col className='w-fc text-size-20' style={{alignContent: 'center', textAlign: 'end'}}>
                            Welcome, {mfrName}
                        </Col>
                    </Row>
                    <svg width= '26px' height='26px'>
                        <linearGradient id="icon-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop stopColor={Theme().colors.gradientColorTwo} offset="0%" />
                        <stop stopColor={Theme().colors.gradientColorOne} offset="100%" />
                        </linearGradient>
                    </svg>
                </Col>
            </Row>
            }
        </>
    )
}

export default PageHeader;